import dayjs from 'dayjs'
import { DateTimeFormat } from '../Constants'

const duplicateCampaignForEdit = compoundCampaign => {
  const { campaign, menuSetting } = compoundCampaign

  let deliveryLocationGroups = []
  if (menuSetting.deliveryLocationGroups) {
    deliveryLocationGroups = menuSetting.deliveryLocationGroups.map(
      stripDeliveryLocationGroup,
    )
    menuSetting.deliveryLocationGroups = deliveryLocationGroups
  }

  campaign.advancedSetting.demographicSetting = stripDemographicSetting(
    campaign.advancedSetting.demographicSetting,
  )

  return {
    campaign: copyCampaign(stripCampaign(campaign)),
    menuSetting: stripMenuSetting(menuSetting),
    demographicSetting: campaign.advancedSetting.demographicSetting,
  }
}

/**
 * キャンペーンから id を除去する。
 */
const stripCampaign = campaign => {
  const { id, insertionOrderBudgets, ...rest } = campaign // eslint-disable-line no-unused-vars
  return {
    ...rest,
    insertionOrderBudgets: insertionOrderBudgets.map(stripInsertionOrderBudget),
  }
}

/**
 * キャンペーン名に prefix を付与する。
 */
const copyCampaign = campaign => ({
  ...campaign,
  name: `copy_${campaign.name}`,
  insertionOrderBudgets: campaign.insertionOrderBudgets.map(
    insertionOrderBudget => {
      const { latestRequest, campaignBudgets } = insertionOrderBudget
      const { temporaryCampaignBudgets } = latestRequest
      return {
        ...insertionOrderBudget,
        latestRequest: {
          ...latestRequest,
          temporaryCampaignBudgets: temporaryCampaignBudgets
            ? temporaryCampaignBudgets.map(copyCampaignBudget)
            : undefined,
        },
        campaignBudgets: campaignBudgets
          ? campaignBudgets.map(copyCampaignBudget)
          : undefined,
      }
    },
  ),
  ipAreaSetting: campaign.ipAreaSetting,
})

/**
 * 案件予算内の終了したキャンペーン予算を除去する。
 */
const stripInsertionOrderBudget = insertionOrderBudget => {
  const { campaignBudgets, latestRequest } = insertionOrderBudget
  const { temporaryCampaignBudgets } = latestRequest
  return {
    ...insertionOrderBudget,
    latestRequest: {
      ...latestRequest,
      temporaryCampaignBudgets: temporaryCampaignBudgets
        ? temporaryCampaignBudgets
            .filter(
              campaignBudget =>
                !dayjs(campaignBudget.endTime).isBefore(dayjs()),
            )
            .map(stripCampaignBudget)
        : undefined,
    },
    campaignBudgets: campaignBudgets
      ? campaignBudgets
          .filter(
            campaignBudget => !dayjs(campaignBudget.endTime).isBefore(dayjs()),
          )
          .map(stripCampaignBudget)
      : undefined,
  }
}

/**
 * キャンペーン予算から id を除去する。
 */
const stripCampaignBudget = campaignBudget => {
  const { id, ...rest } = campaignBudget // eslint-disable-line no-unused-vars
  return rest
}

/**
 * キャンペーン予算の予算を0にし、開始日時が過去であれば本日に変更する。
 */
const copyCampaignBudget = campaignBudget => ({
  ...campaignBudget,
  budget: 0,
  startTime: dayjs(campaignBudget.startTime).isBefore(dayjs())
    ? dayjs()
        .startOf('day')
        .format(DateTimeFormat)
    : campaignBudget.startTime,
})

/**
 * 配信地点グループの id を除去する。
 */
const stripDeliveryLocationGroup = deliveryLocationGroup => {
  const { id, ...rest } = deliveryLocationGroup // eslint-disable-line no-unused-vars
  return rest
}

/**
 * メニュー設定の id を除去する。
 */
const stripMenuSetting = menuSetting => {
  const { id, ...rest } = menuSetting // eslint-disable-line no-unused-vars
  return rest
}

/**
 * デモグラ設定の id を除去する。
 */
const stripDemographicSetting = demographicSetting => {
  const { id, ...rest } = demographicSetting // eslint-disable-line no-unused-vars
  return rest
}

export default duplicateCampaignForEdit
